import React, { useState } from "react";
import FabButton from "../../buttons/fabButton/FabButton";
import ultraWhiteBgButton from "../../../assets/ultra_white_bg_btn.png";
import ultraGreenBgButton from "../../../assets/ultra_green_bg_btn.png";
import { MobileLoginModal } from "../../modal/loginModal/mobile/MobileLoginModal";

type props = {};

export const MobileLogin: React.FC<props> = () => {
  const [isLoginProcessStarted, setIsLoginProcessStarted] =
    useState<boolean>(false);

  return (
    <div style={{ backgroundColor: "#F2EBE1", height: 100000 }}>
      <MobileLoginModal
        isOpen={isLoginProcessStarted}
        onClose={() => setIsLoginProcessStarted(false)}
      />
      <FabButton
        onClick={() => {
          setIsLoginProcessStarted(!isLoginProcessStarted);
        }}
        imageUrl={
          isLoginProcessStarted ? ultraGreenBgButton : ultraWhiteBgButton
        }
        altText={""}
      />
    </div>
  );
};
